import Moment from 'moment';

interface AggregationBucket {
  time: string;
  value: number;
}

export function getClosestTrendsIndex(
  buckets: AggregationBucket[],
  dateString: string
) {
  const bucketTimes = buckets.map((bucket) => bucket.time);

  const minTime = Moment.utc(bucketTimes[0]).valueOf();
  const maxTime = Moment.utc(bucketTimes[buckets.length - 1]).valueOf();
  const cf2DateValue = Moment.utc(dateString).valueOf();

  // if date is not in date range, return -1 as in not found
  if (cf2DateValue < minTime || cf2DateValue > maxTime) {
    return -1;
  }

  return buckets.reduce(
    (closestIdx, bucket, currentIndex) => {
      const bucketTimeValue = Moment.utc(bucket.time).valueOf();

      const diff = Math.abs(bucketTimeValue - cf2DateValue);
      if (diff < closestIdx.minDiff) {
        return { minDiff: diff, index: currentIndex };
      }
      return closestIdx;
    },
    { minDiff: Infinity, index: -1 }
  ).index;
}
